// extracted by mini-css-extract-plugin
module.exports = {"card-container":"_2wTNM","text-wrapper":"_3xY70"};